import pleinSoleil1 from '../images/rooms/plein_soleil/1.png';
import pleinSoleil2 from '../images/rooms/plein_soleil/2.png';
import pleinSoleil3 from '../images/rooms/plein_soleil/3.png';
import pleinSoleil4 from '../images/rooms/plein_soleil/4.png';
import pleinSoleil5 from '../images/rooms/plein_soleil/5.png';
import pleinSoleil6 from '../images/rooms/plein_soleil/6.png';
import pleinSoleil7 from '../images/rooms/plein_soleil/7.png';
import pleinSoleil8 from '../images/rooms/plein_soleil/8.png';
import amoreVuolDireGelosia1 from '../images/rooms/amore_vuol_dire_gelosia/1.png';
import amoreVuolDireGelosia2 from '../images/rooms/amore_vuol_dire_gelosia/2.png';
import amoreVuolDireGelosia3 from '../images/rooms/amore_vuol_dire_gelosia/3.png';
import amoreVuolDireGelosia4 from '../images/rooms/amore_vuol_dire_gelosia/4.png';
import amoreVuolDireGelosia5 from '../images/rooms/amore_vuol_dire_gelosia/5.png';
import amoreVuolDireGelosia6 from '../images/rooms/amore_vuol_dire_gelosia/6.png';
import amoreVuolDireGelosia7 from '../images/rooms/amore_vuol_dire_gelosia/7.png';
import cleopatra1 from '../images/rooms/cleopatra/1.png';
import cleopatra2 from '../images/rooms/cleopatra/2.png';
import cleopatra3 from '../images/rooms/cleopatra/3.png';
import cleopatra4 from '../images/rooms/cleopatra/4.png';
import cleopatra5 from '../images/rooms/cleopatra/5.png';
import cleopatra6 from '../images/rooms/cleopatra/6.png';
import cleopatra7 from '../images/rooms/cleopatra/7.png';
import morganIlPirata1 from '../images/rooms/morgan_il_pirata/1.png';
import morganIlPirata2 from '../images/rooms/morgan_il_pirata/2.png';
import morganIlPirata3 from '../images/rooms/morgan_il_pirata/3.png';
import morganIlPirata4 from '../images/rooms/morgan_il_pirata/4.png';
import morganIlPirata5 from '../images/rooms/morgan_il_pirata/5.png';
import morganIlPirata6 from '../images/rooms/morgan_il_pirata/6.png';
import morganIlPirata7 from '../images/rooms/morgan_il_pirata/7.png';
import morganIlPirata8 from '../images/rooms/morgan_il_pirata/8.png';
import ripley1 from '../images/rooms/il_talento_di_mister_ripley/1.png';
import ripley2 from '../images/rooms/il_talento_di_mister_ripley/2.png';
import ripley3 from '../images/rooms/il_talento_di_mister_ripley/3.png';
import ripley4 from '../images/rooms/il_talento_di_mister_ripley/4.png';
import ripley5 from '../images/rooms/il_talento_di_mister_ripley/5.png';
import ripley6 from '../images/rooms/il_talento_di_mister_ripley/6.png';
import ripley7 from '../images/rooms/il_talento_di_mister_ripley/7.png';
import ripley8 from '../images/rooms/il_talento_di_mister_ripley/8.png';
import ripley9 from '../images/rooms/il_talento_di_mister_ripley/9.png';
import detenuto1 from '../images/rooms/detenuto_in_attesa_di_giudizio/1.png';
import detenuto2 from '../images/rooms/detenuto_in_attesa_di_giudizio/2.png';
import detenuto3 from '../images/rooms/detenuto_in_attesa_di_giudizio/3.png';
import detenuto4 from '../images/rooms/detenuto_in_attesa_di_giudizio/4.png';
import detenuto5 from '../images/rooms/detenuto_in_attesa_di_giudizio/5.png';
import postino1 from '../images/rooms/il_postino/1.png';
import postino2 from '../images/rooms/il_postino/2.png';
import postino3 from '../images/rooms/il_postino/3.png';
import postino4 from '../images/rooms/il_postino/4.png';
import postino5 from '../images/rooms/il_postino/5.png';
import postino6 from '../images/rooms/il_postino/6.png';
import postino7 from '../images/rooms/il_postino/7.png';
import postino8 from '../images/rooms/il_postino/8.png';
import postino9 from '../images/rooms/il_postino/9.png';
import giuro1 from '../images/rooms/giuro_che_ti_amo/1.png';
import giuro2 from '../images/rooms/giuro_che_ti_amo/2.png';
import giuro3 from '../images/rooms/giuro_che_ti_amo/3.png';
import giuro4 from '../images/rooms/giuro_che_ti_amo/4.png';
import giuro5 from '../images/rooms/giuro_che_ti_amo/5.png';
import giuro6 from '../images/rooms/giuro_che_ti_amo/6.png';
import graziella1 from '../images/rooms/graziella/1.png';
import graziella2 from '../images/rooms/graziella/2.png';
import graziella3 from '../images/rooms/graziella/3.png';
import graziella4 from '../images/rooms/graziella/4.png';
import graziella5 from '../images/rooms/graziella/5.png';
import graziella6 from '../images/rooms/graziella/6.png';
import graziella7 from '../images/rooms/graziella/7.png';
import graziella8 from '../images/rooms/graziella/8.png';
import fuoco_su_di_me1 from '../images/rooms/fuoco_su_di_me/1.png';
import fuoco_su_di_me2 from '../images/rooms/fuoco_su_di_me/2.png';
import fuoco_su_di_me3 from '../images/rooms/fuoco_su_di_me/3.png';
import fuoco_su_di_me4 from '../images/rooms/fuoco_su_di_me/4.png';
import fuoco_su_di_me5 from '../images/rooms/fuoco_su_di_me/5.png';
import fuoco_su_di_me6 from '../images/rooms/fuoco_su_di_me/6.png';
import fuoco_su_di_me7 from '../images/rooms/fuoco_su_di_me/7.png';
import francesca_e_nunziata1 from '../images/rooms/francesca_e_nunziata/1.png';
import francesca_e_nunziata2 from '../images/rooms/francesca_e_nunziata/2.png';
import francesca_e_nunziata3 from '../images/rooms/francesca_e_nunziata/3.png';
import francesca_e_nunziata4 from '../images/rooms/francesca_e_nunziata/4.png';
import francesca_e_nunziata5 from '../images/rooms/francesca_e_nunziata/5.png';
import francesca_e_nunziata6 from '../images/rooms/francesca_e_nunziata/6.png';
import francesca_e_nunziata7 from '../images/rooms/francesca_e_nunziata/7.png';
import la_super_testimone1 from '../images/rooms/la_super_testimone/1.png';
import la_super_testimone2 from '../images/rooms/la_super_testimone/2.png';
import la_super_testimone3 from '../images/rooms/la_super_testimone/3.png';
import la_super_testimone4 from '../images/rooms/la_super_testimone/4.png';
import la_super_testimone5 from '../images/rooms/la_super_testimone/5.png';
import la_super_testimone6 from '../images/rooms/la_super_testimone/6.png';
import la_super_testimone7 from '../images/rooms/la_super_testimone/7.png';
import la_super_testimone8 from '../images/rooms/la_super_testimone/8.png';
import la_super_testimone9 from '../images/rooms/la_super_testimone/9.png';

const dbRooms = [
        {
          id: 1,
          stairs: false,
          name: 'Isola di Arturo',
          favorite: false,
          images: [
            ripley3,
            ripley5,
            ripley6,
            ripley7,
          ],
          options: 
          {
            gennaio: '100',
            febbraio: '110',
            marzo: '120',
            aprile: '80',
            maggio: '100',
            giugno: '120',
            luglio: '140',
            agosto: '150',
            settembre: '120',
            ottobre: '190',
            novembre: '200',
            dicembre: '210',
          },
        },
        {
          id: 2,
          stairs: false,
          name: 'Giuro che ti amo',
          favorite: false,
          images: [
            giuro2,
            giuro1,
            giuro3,
            giuro4,
            giuro5,
            giuro6,
          ],
          options: 
          {
            gennaio: '100',
            febbraio: '110',
            marzo: '120',
            aprile: '80',
            maggio: '100',
            giugno: '120',
            luglio: '140',
            agosto: '150',
            settembre: '120',
            ottobre: '190',
            novembre: '200',
            dicembre: '210',
          },
        },
        {
          id: 3,
          stairs: false,
          name: 'Il talento di Mister Ripley',
          images: [
            ripley1,
            ripley2,
            ripley3,
            ripley4,
            ripley5,
            ripley6,
            ripley7,
            ripley8,
            ripley9
          ],
          favorite: false,
          options: 
          {
            gennaio: '100',
            febbraio: '110',
            marzo: '120',
            aprile: '80',
            maggio: '100',
            giugno: '120',
            luglio: '140',
            agosto: '150',
            settembre: '120',
            ottobre: '190',
            novembre: '200',
            dicembre: '210',
          },
        },
        {
          id: 4,
          stairs: false,
          name: 'Detenuto in attesa di giudizio',
          images: [
            detenuto1,
            detenuto2,
            detenuto3,
            detenuto4,
            detenuto5
          ],
          favorite: false,
          options: 
          {
            gennaio: '100',
            febbraio: '110',
            marzo: '120',
            aprile: '80',
            maggio: '100',
            giugno: '120',
            luglio: '140',
            agosto: '150',
            settembre: '120',
            ottobre: '190',
            novembre: '200',
            dicembre: '210',
          },
        },
        {
          id: 5,
          stairs: false,
          name: 'Il postino',
          images: [
            postino1,
            postino2,
            postino3,
            postino4,
            postino5,
            postino6,
            postino7,
            postino8,
            postino9,
          ],
          favorite: true,
          options: 
          {
            gennaio: '100',
            febbraio: '110',
            marzo: '120',
            aprile: '80',
            maggio: '100',
            giugno: '120',
            luglio: '140',
            agosto: '150',
            settembre: '120',
            ottobre: '190',
            novembre: '200',
            dicembre: '210',
          },
        },
        {
          id: 6,
          stairs: false,
          name: 'Graziella',
          favorite: true,
          images: [
            graziella1,
            graziella2,
            graziella3,
            graziella4,
            graziella5,
            graziella6,
            graziella7,
            graziella8
          ],
          options: 
          {
            gennaio: '100',
            febbraio: '110',
            marzo: '120',
            aprile: '80',
            maggio: '100',
            giugno: '120',
            luglio: '140',
            agosto: '150',
            settembre: '120',
            ottobre: '190',
            novembre: '200',
            dicembre: '210',
          },
        },
        {
          id: 7,
          stairs: true,
          name: 'Fuoco su di me',
          favorite: false,
          images: [
            fuoco_su_di_me2,
            fuoco_su_di_me1,
            fuoco_su_di_me3,
            fuoco_su_di_me4,
            fuoco_su_di_me5,
            fuoco_su_di_me6,
            fuoco_su_di_me7
          ],
          options: 
          {
            gennaio: '100',
            febbraio: '110',
            marzo: '120',
            aprile: '80',
            maggio: '100',
            giugno: '120',
            luglio: '140',
            agosto: '150',
            settembre: '120',
            ottobre: '190',
            novembre: '200',
            dicembre: '210',
          },
        },
        {
          id: 8,
          stairs: true,
          name: 'Francesca e Nunziata',
          favorite: false,
          images: [
            francesca_e_nunziata1,
            francesca_e_nunziata2,
            francesca_e_nunziata3,
            francesca_e_nunziata4,
            francesca_e_nunziata5,
            francesca_e_nunziata6,
            francesca_e_nunziata7
          ],
          options: 
          {
            gennaio: '100',
            febbraio: '110',
            marzo: '120',
            aprile: '80',
            maggio: '100',
            giugno: '120',
            luglio: '140',
            agosto: '150',
            settembre: '120',
            ottobre: '190',
            novembre: '200',
            dicembre: '210',
          },
        },
        {
          id: 9,
          stairs: true,
          name: 'Amore vuol dire gelosia',
          images: [
            amoreVuolDireGelosia1,
            amoreVuolDireGelosia2,
            amoreVuolDireGelosia3,
            amoreVuolDireGelosia4,
            amoreVuolDireGelosia5,
            amoreVuolDireGelosia6,
            amoreVuolDireGelosia7,
          ],
          favorite: true,
          options: 
          {
            gennaio: '100',
            febbraio: '110',
            marzo: '120',
            aprile: '80',
            maggio: '100',
            giugno: '120',
            luglio: '140',
            agosto: '150',
            settembre: '120',
            ottobre: '190',
            novembre: '200',
            dicembre: '210',
          },
        },
        {
          id: 10,
          stairs: true,
          name: 'Morgan il pirata',
          images: [
            morganIlPirata1,
            morganIlPirata2,
            morganIlPirata3,
            morganIlPirata4,
            morganIlPirata5,
            morganIlPirata6,
            morganIlPirata7,
            morganIlPirata8
          ],
          favorite: true,
          options: 
          {
            gennaio: '100',
            febbraio: '110',
            marzo: '120',
            aprile: '80',
            maggio: '100',
            giugno: '120',
            luglio: '140',
            agosto: '150',
            settembre: '120',
            ottobre: '190',
            novembre: '200',
            dicembre: '210',
          },
        },
        {
          id: 11,
          stairs: false,
          name: 'Cleopatra',
          images: [
            cleopatra1,
            cleopatra2,
            cleopatra3,
            cleopatra4,
            cleopatra5,
            cleopatra6,
            cleopatra7,
          ],
          favorite: false,
          options: 
          {
            gennaio: '100',
            febbraio: '110',
            marzo: '120',
            aprile: '80',
            maggio: '100',
            giugno: '120',
            luglio: '140',
            agosto: '150',
            settembre: '120',
            ottobre: '190',
            novembre: '200',
            dicembre: '210',
          },
        },
        {
          id: 12,
          stairs: false,
          name: 'La super testimone',
          favorite: false,
          images: [
            la_super_testimone1,
            la_super_testimone2,
            la_super_testimone3,
            la_super_testimone4,
            la_super_testimone5,
            la_super_testimone6,
            la_super_testimone7,
            la_super_testimone8,
            la_super_testimone9
          ],
          options: 
          {
            gennaio: '100',
            febbraio: '110',
            marzo: '120',
            aprile: '80',
            maggio: '100',
            giugno: '120',
            luglio: '140',
            agosto: '150',
            settembre: '120',
            ottobre: '190',
            novembre: '200',
            dicembre: '210',
          },
        },
        {
          id: 20,
          stairs: false,
          name: 'Plein soleil',
          images: [
            pleinSoleil1,
            pleinSoleil2,
            pleinSoleil3,
            pleinSoleil4,
            pleinSoleil5,
            pleinSoleil6,
            pleinSoleil7,
            pleinSoleil8
          ],
          favorite: true,
          options: 
          {
            gennaio: '100',
            febbraio: '110',
            marzo: '120',
            aprile: '80',
            maggio: '100',
            giugno: '120',
            luglio: '140',
            agosto: '150',
            settembre: '120',
            ottobre: '190',
            novembre: '200',
            dicembre: '210',
          },
        }
      ]



export default dbRooms;